module.exports = __webpack_public_path__ + "img/device_1011_1.a98fd691.svg";